import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styles from './index.module.scss';
import { useBidding } from 'src/models/bids/BidFull/hooks';
import { faList } from '@fortawesome/pro-light-svg-icons';
import { Skeleton } from 'antd';

export const TasksStatistic: FC = () => {
  const { t } = useTranslation();
  const { data, loading } = useBidding();
  const stats = data?.statistic?.stats ?? [];
  const total = data?.statistic?.total ?? 0;

  return loading ? (
    <Skeleton active />
  ) : data?.statistic ? (
    <section className={styles.blocks}>
      {stats.map(([statName, statValue]) => (
        <div className={styles.block} key={statName}>
          <span className={styles.name}>{t(`BiddingTool.States.${statName}`)}</span>
          <div className={styles.value}>
            <FontAwesomeIcon
              className={styles.statIcon}
              icon={statValue.icon.defaultIcon ?? faList}
              style={{ color: statValue.icon.color }}
            />
            <span className={styles.statCount}>{statValue.count}</span>
            {statName !== 'totalTasks' && (
              <span className={styles.statPercent}>{`(${
                total > 0 ? Math.round((100 * statValue.count) / total) : 0
              }%)`}</span>
            )}
          </div>
        </div>
      ))}
    </section>
  ) : null;
};

export default TasksStatistic;
